import TextField from "../../TextField"
import { useEffect, useState } from "react"
import SmallestHeadingComponent from "../../SmallestHeadingComponent"
import Button from "../../Button"
import MoveContentToRight from "../../MoveContentToRight"
import {
    GetPatientMedicationInformationSpecification,
    InsertPatientMedicationSpecification,
    ResetMedicationSpecification
} from "pokal_api"
import { dispatchThunk } from "../../../redux/thunk/thunkify"
import { useAppDispatch, useAppSelector } from "../../../redux/store/hooks"
import {
    medicationOnboardingIsRunning,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../../redux/Onboarding"

interface MedicationListAddProps {
    patient: string
}

function MedicationListAdd(props: MedicationListAddProps) {

    const onboardingIsRunning = useAppSelector(selectOnboardingIsRunningState)
    const onboardingStep = useAppSelector(selectOnboardingStep)

    const [pzn, setPzn] = useState<string>("")

    function evaluate(): boolean {
        return pzn.length > 0
    }

    function clear() {
        setPzn("")
    }

    const dispatch = useAppDispatch()

    function onSubmit() {
        InsertPatientMedicationSpecification.request({
            patient: props.patient,
            pzn: pzn
        })
            .then(() => {
                dispatchThunk(
                    dispatch,
                    GetPatientMedicationInformationSpecification,
                    {
                        patient: props.patient
                    },
                    {
                        do: () => clear()
                    }
                )
            })
            .catch(() => {
                /*Ignore*/
            })
    }

    function onReset() {
        const success = window.confirm(
            "Bitte bestätigen Sie, dass Sie die gesamte Medikation der Patient:in zurücksetzen möchten."
        )
        if (success) {
            ResetMedicationSpecification.request({
                patient: props.patient
            }).then(() => {
                dispatchThunk(
                    dispatch,
                    GetPatientMedicationInformationSpecification,
                    {
                        patient: props.patient
                    }
                )
            })
        }
    }

    useEffect(() => {
        let updated = pzn.trim()
        while(updated.startsWith("0"))
            updated = updated.substring(1)
        if(updated !== pzn)
            setPzn(updated)
    }, [pzn])

    return (
        <div className={"flex flex-col space-y-4"}>
            <SmallestHeadingComponent>
                Medikationseintrag hinzufügen
            </SmallestHeadingComponent>
            <div className={"w-full flex items-center"}>
                <div className={"flex-1"}>
                    <TextField
                        width={"100%"}
                        placeholder={"PZN Nummer hier eingeben"}
                        type={"text"}
                        inputState={[pzn, setPzn]}
                    />
                </div>
                <div className={"mr-4 ml-4"}>
                    <Button onClick={onSubmit} disabled={!evaluate() || medicationOnboardingIsRunning(onboardingIsRunning, onboardingStep)}>
                        Eintrag hinzufügen
                    </Button>
                </div>
            </div>
            <div className={"flex mr-4"}>
                <MoveContentToRight>
                    <div className={"flex space-x-2"}>
                        <Button disabled={medicationOnboardingIsRunning(onboardingIsRunning, onboardingStep)} tint={"bg-rose-600"} onClick={onReset}>
                            Medikation zurücksetzen
                        </Button>
                    </div>
                </MoveContentToRight>
            </div>
        </div>
    )
}

export default MedicationListAdd
